import {useCallback, useRef, useEffect} from 'react';
import {Subject} from 'rxjs';

type PubSubData = {
	action: string;
	payload: unknown;
};

type PubSubObserverFn<D extends PubSubData> = (data: D) => void;

/**
 * A basic pub sub hook
 * @deprecated was trying a lot of things out and we should eliminate this (as well as any rxjs code)
 * @example
 * type ObserverData = {action: string, payload: MyCustomPayload}
 * ...
 * const {subscribe, emit} = usePubSub<ObserverData>();
 */
export const usePubSub = <D extends PubSubData>() => {
	const oberver = useRef(new Subject<D>());

	const subscribe = useCallback(
		(taskObserver: PubSubObserverFn<D>) =>
			oberver.current.subscribe(taskObserver),
		[],
	);

	const emit = useCallback((data: D) => oberver.current.next(data), []);

	useEffect(() => {
		return () => {
			// oberver.current.unsubscribe();
			oberver.current.complete();
		};
	}, []);

	return {
		oberver,
		emit,
		subscribe,
	};
};

export default usePubSub;
